import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../Styles/Common.module.css';
import BreadcrumbComponent from "../Common/CommonSections/Breadcrum";
import { Link } from "react-router-dom";

const RegulatoryInformationPage = ()=>{
    return(
        <div>
            <BreadcrumbComponent home='Home' listOne="Regulatory Information" />
            <div className={Style.pageTitle + ' ' + Style.marginUp90}>
                <Container>
                    <Row>
                        <Col>
                            <div className={Style.sectionTitle}>
                                <h2>Regulatory Information</h2>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className={Style.aboutmayocollege + ' ' + Style.pageBoder}>
                                <p>Thank you for your interest in Mayo College Alumni Association Delhi. Below is important regulatory information to ensure transparency and compliance with applicable laws and regulations:</p>
                                <h3>Legal Entity:</h3>
                                <p>Mayo College Alumni Association Delhi is a non-profit Association registered under SOCIEITES REGISTRATION ACT OF 1860.</p>
                                <h3>Registration Details:</h3>
                                <ul>
                                    <li><strong>Registration Number: S/68893/2010</strong></li>
                                    <li><strong>Date of Registration: 22ND MARCH 2010</strong></li>
                                    <li><strong>Registered Office: C - 39, NITI BAGH, NEW DELHI</strong></li>
                                </ul>
                                <h3>Tax Exemption Status:</h3>
                                <p><strong>Mayo College Alumni Association Delhi has been granted tax-exempt under 11-Clause (i) of first proviso to sub-section (5) of section 80G of Income Tax Act. vide Application No 377265070280821 dated 24.09.2021bfrom AY 2022-23 to AY 2026-27.</strong></p>
                                <h3>Governing Documents:</h3>
                                <p>The association operates in accordance with its constitution, bylaws, and any other governing documents. These documents are available upon request.</p>
                                <h3>Board of Directors:</h3>
                                <p>Mayo College Alumni Association Delhi is governed by a Board of Members responsible for overseeing the association's operations and strategic direction. The current list of board members is available upon request.</p>
                                <h3>Financial Information:</h3>
                                <p>Annual financial statements are prepared and audited by S K Vohra& Co. Copies of these statements are available for review by members upon request.</p>
                                <h3>Code of Conduct:</h3>
                                <p>Mayo College Alumni Association Delhi adheres to a Code of Conduct outlining ethical standards and expectations for members, volunteers, and staff. The Code of Conduct is available on our website.</p>
                                <h3>Compliance with Data Protection Laws:</h3>
                                <p>Mayo College Alumni Association Delhi is committed to complying with data protection laws, including but not limited to GDPR/other applicable regulations. Please refer to our Privacy Policy for details.</p>
                                <h3>Contact Information:</h3>
                                <p>For any regulatory inquiries or additional information, please contact us at <strong><Link to='mailto:secretary@mayoalumni.in'>secretary@mayoalumni.in</Link></strong> .</p>
                                <p>By engaging with Mayo College Alumni Association Delhi, you acknowledge awareness of the regulatory information provided above.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default RegulatoryInformationPage;